import type { FuncOverrideComponent } from '../theme.types';

export const MuiFormLabel: FuncOverrideComponent<'MuiFormLabel'> = theme => ({
  styleOverrides: {
    root: {
      ...theme.typography.caption,
    },
  },
});
